module.exports = __webpack_public_path__ + "static/media/(H)-14_-_bijuterias_-_acessorios.ddb00f42.jpg";